export default {"src":"/_next/static/media/stressMotivation.3926d35a.svg","height":594,"width":1048,"blurWidth":0,"blurHeight":0};